import { type SvgProps, SvgWrapper } from '../utils';

export function CheckCircledIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z" />
      <path d="M15.9697 9.46973C16.2626 9.17683 16.7374 9.17683 17.0303 9.46973C17.3232 9.76262 17.3232 10.2374 17.0303 10.5303L11.5303 16.0303C11.2374 16.3232 10.7626 16.3232 10.4697 16.0303L7.46973 13.0303C7.17683 12.7374 7.17683 12.2626 7.46973 11.9697C7.76262 11.6768 8.23738 11.6768 8.53027 11.9697L11 14.4395L15.9697 9.46973Z" />
    </SvgWrapper>
  );
}
